import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsAG: CultureInfo = {
  name: 'es-AG',
  displayName: 'español (Antigua y Barbuda)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-AG',
  parent: CultureInfoEs
};
